<img [rpLazyLoadImage]="uri()" alt="Preview" />
